import React from "react";

import { createSvgIcon } from "@mui/material/utils";

export const UpgradeIcon = createSvgIcon(
 <svg
  id="Livello_1"
  data-name="Livello 1"
  xmlns="http://www.w3.org/2000/svg"
  viewBox="0 0 20 20"
  fill="currentColor">
  <path d="M17.07,2.93C15.18,1.04,12.67,0,10,0S4.82,1.04,2.93,2.93C1.04,4.82,0,7.33,0,10s1.04,5.18,2.93,7.07c1.89,1.89,4.4,2.93,7.07,2.93s5.18-1.04,7.07-2.93c1.89-1.89,2.93-4.4,2.93-7.07s-1.04-5.18-2.93-7.07h0ZM15.97,15.97c-1.59,1.59-3.71,2.47-5.97,2.47s-4.37-.88-5.97-2.47-2.47-3.71-2.47-5.97.88-4.37,2.47-5.97,3.71-2.47,5.97-2.47,4.37.88,5.97,2.47,2.47,3.71,2.47,5.97-.88,4.37-2.47,5.97h0Z" />
  <path d="M10.55,3.95c-.31-.31-.8-.31-1.1,0l-4.93,4.93c-.31.31-.31.8,0,1.1.15.15.35.23.55.23s.4-.08.55-.23l3.6-3.6v9.1c0,.43.35.78.78.78s.78-.35.78-.78V6.39l3.6,3.6c.31.31.8.31,1.1,0s.31-.8,0-1.1l-4.93-4.93Z" />
 </svg>,
 "Upgrade"
);
